import { isPlatform } from '@ionic/core';
import { Plugins } from '@capacitor/core';
import { isArray, last } from 'lodash';
import differenceInHours from 'date-fns/difference_in_hours';
import differenceInWeeks from 'date-fns/difference_in_weeks';
import isSameDay from 'date-fns/is_same_day';

const isEachDay = notificationTemplate =>
  notificationTemplate.frequencyUnit === 'day';
const isEachHour = notificationTemplate =>
  notificationTemplate.frequencyUnit === 'hour';
const isEachWeek = notificationTemplate =>
  notificationTemplate.frequencyUnit === 'week';
const isEachVisit = notificationTemplate =>
  notificationTemplate.frequencyUnit === 'unique visit';

const meetsDayCriteria = notification => {
  const { template, timeEntries } = notification;
  const now = new Date();
  const timeLastShown = last(timeEntries);
  const dailyEntries = timeEntries.filter(timeEntry =>
    isSameDay(timeEntry, timeLastShown),
  );

  return (
    !isSameDay(now, timeLastShown) || dailyEntries.length < template.frequency
  );
};

const meetsHourCriteria = notification => {
  const { template, timeEntries } = notification;
  const now = new Date();
  const hourlyLog = timeEntries.filter(
    timeEntry => differenceInHours(now, timeEntry) < 1,
  );

  return hourlyLog.length < template.frequency;
};

const meetsWeekCriteria = notification => {
  const { template, timeEntries } = notification;
  const now = new Date();
  const weeklyLog = timeEntries.filter(
    timeEntry => differenceInWeeks(now, timeEntry) < 1,
  );

  return weeklyLog.length < template.frequency;
};

export const isNotificationInFrequency = notification => {
  if (isEachDay(notification.template)) return meetsDayCriteria(notification);
  if (isEachHour(notification.template)) return meetsHourCriteria(notification);
  if (isEachWeek(notification.template)) return meetsWeekCriteria(notification);

  return isEachVisit(notification.template);
};

export const meetFrequencyCriteria = notification =>
  notification.template.isActive && isNotificationInFrequency(notification);

export const requestPermissionNotification = () => {
  const { LocalNotifications } = Plugins;

  const requestPermission = async () => {
    await LocalNotifications.requestPermission();
  };

  setTimeout(() => requestPermission(), 1000);
};

export const openNotification = (notification = {}) => {
  if (isPlatform('android') || isPlatform('ios')) {
    // Breaks if run on web
    const { body, title, id } = notification;
    const { LocalNotifications } = Plugins;

    LocalNotifications.schedule({
      notifications: [
        {
          title: title,
          body: body,
          id: id,
          sound: null,
          attachments: null,
          actionTypeId: '',
          extra: null,
        },
      ],
    });
  }
};

export const isAtDoctor = locationTypeId => locationTypeId === 0;
export const isAtPharmacy = locationTypeId => locationTypeId === 1;
export const isAtHome = locationTypeId => locationTypeId === 2;

export function getNotificationTitle(locationTypeId) {
  if (isAtHome(locationTypeId)) return "You're at Home";
  if (isAtDoctor(locationTypeId)) return "You're at the Doctor's";
  if (isAtPharmacy(locationTypeId)) return "You're at the Pharmacy";

  return '';
}

export function getNotificationGroups(notificationsReceived) {
  let notifications = isArray(notificationsReceived)
    ? notificationsReceived
    : Object.values(notificationsReceived);
  const frequencyNotificationTemplates = [];
  const timeOfDayNotificationTemplates = [];

  notifications.forEach(notificationTemplate => {
    if (notificationTemplate.timeOfDay) {
      timeOfDayNotificationTemplates.push(notificationTemplate);
    } else {
      frequencyNotificationTemplates.push(notificationTemplate);
    }
  });

  return { frequencyNotificationTemplates, timeOfDayNotificationTemplates };
}



// WEBPACK FOOTER //
// ./src/util/notifications.js